module.exports = __webpack_public_path__ + "fonts/logo-minimal.svg";